import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M134.4 33.02H71.575L51.0475 13.385C50.7863 13.1405 50.4428 13.0031 50.085 13H5.6C2.5025 13 0 15.5025 0 18.6V122.2C0 125.298 2.5025 127.8 5.6 127.8H134.4C137.497 127.8 140 125.298 140 122.2V38.62C140 35.5225 137.497 33.02 134.4 33.02Z",
		fill: "#26292E"
	})
});
export default SvgFolder;
